import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  active: boolean;
  routeName: string;
  icon?: ReactElement;
  title: string;
  setShowMenu: () => void;
}

function SidebarButton(props: Props) {
  return (
    <div className='flex flex-col gap-2'>
      <Link
        to={props.routeName}
        onClick={() => props.setShowMenu()}
        className='2xl:h-8 2xl:px-3 2xl:py-5 group flex flex-row w-full gap-4 justify-between items-center cursor-pointer hover:bg-gray-3'
      >
        <div className='flex flex-row items-center gap-3'>
          <div
            className={`w-4 flex justify-center prose-mainMenuL2ItemActive 2xl:prose-mainMenuL1ItemActive ${
              props.active ? 'text-black font-bold' : 'text-gray-60'
            }`}
          >
            {props.icon}
          </div>
          <span
            className={`prose-mainMenuL2ItemActive 2xl:prose-mainMenuL1ItemActive ${
              props.active ? 'text-black font-bold' : 'text-gray-60'
            }`}
          >
            {props.title}
          </span>
        </div>
      </Link>
    </div>
  );
}

export default SidebarButton;
